import App from '../../../app'
const AMPLITUDE_EVENT_NAME = "Pageview: Alerts";
/**
 * @deprecated Use alerts-board component
 */
export default function DashboardMainPageController(
  $scope,
  $rootScope,
  AlertsService,
  $filter,
  EquipmentService,
  gettextCatalog,
  gettext,
) {
  'ngInject';

  $scope.alerts = [];
  $scope.alertsByPage = [];
  $scope.filteredAlerts = [];
  $scope.search = {
    text: '',
  };
  $scope.errorFlag = false;
  $scope.errorText = '';
  var userEmail = '';
  $scope.currentUser = $rootScope.currentUser;
  var datapointDescriptors = $rootScope.datapointDescriptors;

  //variable use to refresh map
  $scope.alertGetCleared = false;

  //Sorting
  $scope.predicate = 'name';
  $scope.reverse = false;
  var orderBy = $filter('orderBy');

  //Sort filteredAlerts
  $scope.orderAlerts = function (predicate, reverse) {
    $scope.predicate = predicate;
    $scope.reverse = $scope.predicate === predicate ? !$scope.reverse : false;

    angular.forEach($scope.filteredAlerts, function (alert) {
      alert[predicate] = alert[predicate];
    });
    $scope.filteredAlerts = orderBy($scope.filteredAlerts, predicate, $scope.reverse);
    $scope.displayAlertsByPage();
  };

  this.$onInit = () => {
    App.amplitude.track(AMPLITUDE_EVENT_NAME);
  }

  //Pagination
  $scope.maxSize = 1;
  $scope.current = {
    alertPage: 1,
  };
  $scope.itemsPerPage = 5;

  // to extract alert status to po file for translation
  gettext('Acknowledged');
  gettext('Cleared');
  gettext('Closed'); // used in equipment alert tab
  gettext('Active');

  //displayAlertsByPage() is used to set the legnth of paging needed for AlertsDashboard.
  $scope.displayAlertsByPage = function () {
    $scope.totalItems = $scope.filteredAlerts.length;
    var begin = ($scope.current.alertPage - 1) * $scope.itemsPerPage;
    var end = begin + $scope.itemsPerPage;
    $scope.alertsByPage = $scope.filteredAlerts.slice(begin, end);
  };

  //Calls displayALertsByPage(), everytime the the user changes the page.
  $scope.pageChanged = function () {
    $scope.displayAlertsByPage();
  };

  //applyFilter searchs the alerts[] for anything matching the search input.
  $scope.applyFilter = function () {
    $scope.filteredAlerts = $filter('filter')($scope.alerts, $scope.search.text);
    $scope.displayAlertsByPage();
  };

  $scope.select = function (index) {
    $scope.index = index;
  };

  //CSV file
  $scope.getCsvFileName = function () {
    if (!$scope.alertsByPage) return '';

    var fileName = gettextCatalog.getString('data_export');
    var name = gettextCatalog.getString('Active_Alerts');
    fileName += '.' + name;
    return fileName + '.csv';
  };

  $scope.getCsvData = function () {
    var CsvData = [];

    var headers = {
      Priority: 'Priority',
      'Time Active': 'Time Active',
      Asset: 'Asset',
      AlertName: 'AlertName',
      AlertEvent: 'AlertEvent',
      Status: 'Status',
    };

    CsvData.push(headers);

    for (var i = 0; i < $scope.alerts.length; i++) {
      var priority = $scope.alerts[i].priority;
      var activeTimeOfAlert = $filter('TableDateFilter')($scope.alerts[i].timestamp);
      var equipment = $scope.alerts[i].equipment.name;
      var alertName = $scope.alerts[i].name;
      var alertEvent = $scope.alerts[i].series.tags[0];
      var status = $scope.alerts[i].status;

      var csvObject = {
        Priority: priority,
        'Time Active': activeTimeOfAlert,
        Asset: equipment,
        AlertName: alertName,
        AlertEvent: alertEvent,
        Status: status,
      };

      CsvData.push(csvObject);
    }
    return CsvData;
  };
}
